import "client-only";
import { createStore } from "jotai";

const store = createStore();

export const getStore = () => store;
